import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";
export const actionTypes = {
    DEALER_CONTACT_POST_FAILURE: "DEALER_CONTACT_POST_FAILURE",
    DEALER_CONTACT_POST_REQUEST: "DEALER_CONTACT_POST_REQUEST",
    DEALER_CONTACT_POST_SUCCESS: "DEALER_CONTACT_POST_SUCCESS",

    DEALER_CONTACT_DELETE_REQUEST: "DEALER_CONTACT_DELETE_REQUEST",
    DEALER_CONTACT_DELETE_SUCCESS: "DEALER_CONTACT_DELETE_SUCCESS",
    DEALER_CONTACT_DELETE_FAILURE: "DEALER_CONTACT_DELETE_FAILURE",

    DEALER_CONTACT_SET: "DEALER_CONTACT_SET",
    DEALER_CONTACT_CLEAR: "DEALER_CONTACT_CLEAR"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.DEALER_CONTACT_CLEAR
    }),
    set: (dealerContacts: any) => ({
        type: actionTypes.DEALER_CONTACT_SET,
        payload: { dealerContacts }
    }),

    postRequest: (data) => ({
        type: actionTypes.DEALER_CONTACT_POST_REQUEST,
        payload: { data },
        [WAIT_FOR_ACTION]: actionTypes.DEALER_CONTACT_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.DEALER_CONTACT_POST_FAILURE
    }),
    postSuccess: (data) => ({
        type: actionTypes.DEALER_CONTACT_POST_SUCCESS,
        payload: { data }
    }),
    postFailure: (error: Error) => ({
        type: actionTypes.DEALER_CONTACT_POST_FAILURE,
        error
    }),

    deleteRequest: (data) => ({
        type: actionTypes.DEALER_CONTACT_DELETE_REQUEST,
        payload: { data },
        [WAIT_FOR_ACTION]: actionTypes.DEALER_CONTACT_DELETE_SUCCESS,
        [ERROR_ACTION]: actionTypes.DEALER_CONTACT_DELETE_FAILURE
    }),
    deleteSuccess: (id: Array<any>) => ({
        type: actionTypes.DEALER_CONTACT_DELETE_SUCCESS,
        payload: { id }
    }),
    deleteFailure: (error: Error) => ({
        type: actionTypes.DEALER_CONTACT_DELETE_FAILURE,
        error
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
